import { render } from "./TransformGui.vue?vue&type=template&id=8ad6bd56"
import script from "./TransformGui.vue?vue&type=script&lang=js"
export * from "./TransformGui.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__